module.exports = __webpack_public_path__ + "3cec6391811239c52d7cb1b362c10e0c.svg";